import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['wrapper']
  static classes = ['checked', 'unchecked']
  static values = {
    selected: { type: Number, default: 0 },
  }

  connect() {
    const ratingFromUrl = this.ratingFromUrl()
    const checkedInput = this.element.querySelector('input[type="radio"]:checked')

    if (ratingFromUrl) {
      const parsed = this.parseIntOrNull(ratingFromUrl)
      if (parsed != null) this.selectedValue = parsed
    } else if (checkedInput) {
      const parsed = this.parseIntOrNull(checkedInput.value)
      if (parsed != null) this.selectedValue = parsed
    }

    if (this.selectedValue) this.setRating(this.selectedValue, { dispatchChange: false })
  }

  ratingFromUrl() {
    const url = new URL(window.location.href)
    return url.searchParams.get('star_rating')
  }

  rate(event) {
    this.applyFromElement(event.currentTarget, { persist: true })
  }

  preview(event) {
    this.applyFromElement(event.currentTarget, { persist: false })
  }

  reset() {
    this.setRating(this.selectedValue || 0, { dispatchChange: false })
  }

  applyFromElement(element, { persist }) {
    const value = this.extractValue(element)
    if (value == null) return

    if (persist) this.selectedValue = value
    this.setRating(value, { dispatchChange: persist })
  }

  setRating(value, { dispatchChange = false } = {}) {
    const rating = Number(value) || 0

    this.wrapperTargets.forEach(wrapper => {
      const input = wrapper.querySelector('input')
      const icon = wrapper.querySelector('[data-icon]')

      if (!input || !icon) return

      const inputValue = this.parseIntOrNull(input.value)
      if (inputValue == null) return

      const isActive = inputValue <= rating
      const shouldBeChecked = inputValue === rating

      this.updateIconState(icon, isActive)
      input.checked = shouldBeChecked

      // Dispatch change event for other controllers listening to form changes
      // Only dispatch when actually selecting (not previewing on hover)
      if (dispatchChange && shouldBeChecked) {
        input.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }

  updateIconState(icon, isActive) {
    if (isActive) {
      icon.classList.add(...this.checkedClasses)
      icon.classList.remove(...this.uncheckedClasses)
    } else {
      icon.classList.remove(...this.checkedClasses)
      icon.classList.add(...this.uncheckedClasses)
    }
  }

  extractValue(element) {
    if (!element) return null

    const datasetValue = element.dataset?.value
    const fromDataset = this.parseIntOrNull(datasetValue)
    if (fromDataset != null) return fromDataset

    if (typeof element.value !== 'undefined') {
      const fromElement = this.parseIntOrNull(element.value)
      if (fromElement != null) return fromElement
    }

    const input = element.querySelector?.('input')
    if (input) {
      const fromInput = this.parseIntOrNull(input.value)
      if (fromInput != null) return fromInput
    }

    return null
  }

  parseIntOrNull(value) {
    if (value == null) return null

    const parsed = parseInt(value, 10)
    return Number.isNaN(parsed) ? null : parsed
  }
}